import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { list, create } from 'actions/data'
import { getContact } from 'actions/contacts'
import {
  FormControl,
  Input,
  // InputAdornment,
  Select,
  MenuItem,
  withStyles,
  FormHelperText,
  ListSubheader,
  Divider,
  ListItemIcon,
  // ListItemText,
} from '@material-ui/core'
import { Person } from '@material-ui/icons'
import { AccountConvert } from 'mdi-material-ui'
import {
  receiveContact,
  handleDefaultFieldChange,
} from 'actions/contacts/addOrEdit'
import { updateContactWithUser } from 'actions/roundRobin'
import { read } from 'actions/data'
import { openSnackbar } from 'actions/view'

const styles = theme => ({
  // notchedOutline: {
  // 	borderRadius: 28,
  // 	paddingLeft: '40px !important',
  // },
  formHelperTextRoot: {
    // marginLeft: 32,
  },
  icon: { color: theme.palette.secondary.main },
})

class UserAssignment extends Component {
  componentDidMount() {
    // this.forceUpdate()
    this.props.list('account/user', 'user_name')
    this.props.list('account/ap')
    this.props.read(null, 'account/ap/status', null, 'none')
  }

  render() {
    const {
      value,
      disabled,
      error,
      classes,
      assignmentPoolsLength,
      handleDefaultFieldChange,
    } = this.props

    if (!assignmentPoolsLength) {
      return null
    }

    const items = Object.values(this.props.users || {}).map(user => ({
      label:
        user?.user_name === this.props.currentUser
          ? 'Me'
          : `${user?.first_name || ''} ${user?.last_name || ''}`,
      value: `user_${user?.user_name}`,
    }))

    const assignmentPools = Object.values(this.props.assignmentPools || {}).map(
      poolObj => ({
        label: poolObj?.name,
        value: `pool_${poolObj?.id}_${poolObj?.name}`,
      }),
    )

    return (
      <div>
        {/* <div style={{ marginTop: 15, marginBottom: 7 }}>
					Who should we assign this contact to?
				</div> */}
        <div>
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            User assignment
          </FormHelperText>
          <FormControl
            fullWidth
            variant="outlined"
            disabled={disabled}
            error={Boolean(error)}
          >
            <Select
              value={disabled ? 'user_unassigned' : value}
              onChange={e => {
                if (e?.target?.value?.slice?.(0, 5) === 'user_') {
                  // console.log('user_')

                  handleDefaultFieldChange(
                    'vastuser',
                    e?.target?.value === 'user_unassigned'
                      ? null
                      : e?.target?.value?.slice?.(5),
                  )

                  this.props
                    .updateContactWithUser(
                      e?.target?.value === 'user_unassigned'
                        ? null
                        : e?.target?.value?.slice?.(5),
                    )
                    .then(payload => this.props.receiveContact(payload))
                }

                if (e?.target?.value?.slice?.(0, 5) === 'pool_') {
                  // console.log('pool_')
                  const stringArr = e.target.value.split('_')
                  const isDefault = stringArr[2] === 'default'

                  const entity = isDefault
                    ? {
                        use_default_assignment_pool: true,
                      }
                    : {
                        use_default_assignment_pool: false,
                        assignmentpool_id: parseInt(stringArr[1]),
                      }

                  this.props
                    .create({
                      entity,
                      noReturnValue: true,
                      path: `contact/${this.props.contactID}/assign`,
                      hasSchema: false,
                      snackbarMessage: `Successfully assigned contact via ${stringArr[2]}!`,
                    })
                    .then(() => {
                      this.props
                        .getContact(this.props.contactID)
                        .then(payload => {
                          this.props.receiveContact(payload)

                          if (payload?.vastuser) {
                            const user = this.props.users?.[payload.vastuser]

                            const userFullName = user
                              ? user?.user_name === this.props.currentUser
                                ? 'you'
                                : `${user?.first_name || ''} ${
                                    user?.last_name || ''
                                  }`
                              : 'unknown'

                            this.props.openSnackbar({
                              type: 'success',
                              message: `This contact is now assigned to ${userFullName}`,
                            })
                          } else {
                            this.props.openSnackbar({
                              type: 'success',
                              message: `Contact is now unassigned`,
                            })
                          }
                        })
                    })
                }
              }}
              input={<Input id={`formTextFieldUserAssignment`} />}
            >
              <ListSubheader>Assign to a pool:</ListSubheader>
              {assignmentPools.map(item => (
                <MenuItem
                  key={`assignmentPoolValue${item.value}`}
                  value={item.value}
                >
                  <ListItemIcon>
                    <AccountConvert className={classes.icon} />
                  </ListItemIcon>
                  {item.label}
                </MenuItem>
              ))}
              <Divider />
              <ListSubheader>Assign to:</ListSubheader>
              <MenuItem
                // disabled
                value="user_unassigned"
              >
                Unassigned
              </MenuItem>
              {items.map(item => (
                <MenuItem
                  key={`userAssignmentValue${item.value}`}
                  value={item.value}
                >
                  <ListItemIcon>
                    <Person className={classes.icon} />
                  </ListItemIcon>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error={Boolean(error)}>{error}</FormHelperText>
          </FormControl>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    const currentUser =
      state?.auth?.session?.idToken?.payload?.['cognito:username']

    const disabled = !state.data?.['account/ap/status']?.enabled

    return {
      users: state.data?.['account/user'] || {},
      value: state.addOrEditContact?.fields?.vastuser?.value
        ? `user_${state.addOrEditContact.fields.vastuser.value}`
        : `user_unassigned`,
      assignmentPoolsLength: Object.values(state.data?.['account/ap'] || {})
        .length,
      currentUser,
      disabled,
      assignmentPools: state.data?.['account/ap'],
      contactID: state.addOrEditContact.contactID,
    }
  },
  dispatch =>
    bindActionCreators(
      {
        list,
        updateContactWithUser,
        receiveContact,
        handleDefaultFieldChange,
        read,
        create,
        getContact,
        openSnackbar,
      },
      dispatch,
    ),
)(withStyles(styles)(UserAssignment))
